import PropertyValue from '@/components/Typography/PropertyValue';
import { NOT_ASSIGNED_LABEL } from '@/configs/reserved-word';
import DataOriginSelectModal from '@/features/Feedback/field/DataOrigin/DataOriginDropdown/DataOriginSelectModal';
import { useElementRef } from '@/hooks/pure/useElementRef';
import useFeedbackListStore from '@/stores/Feedback/FeedbackListStore';
import useDropdownStore from '@/stores/pure/DropdownStore';

import { useFeedbackDetailContext } from '../../context/FeedbackDetailContext';
import { PropertyRowWrapper } from './PropertyRowWrapper';
import type { CommonFieldProps } from './types';
import { getDropdownKey } from './utils';

export const DataOrioginField = (
  props: CommonFieldProps & {
    feedback_alias: string;
    data_origin: string | null;
  },
) => {
  const { elementRef: triggerElement, setElementRef } =
    useElementRef<HTMLDivElement>();
  const setCurrDropdown = useDropdownStore((state) => state.setCurrDropdown);
  const changeDataOrigin = useFeedbackListStore(
    (state) => state.changeDataOrigin,
  );
  const { updateDetail } = useFeedbackDetailContext();

  const onPropertyClick = (e: React.MouseEvent, fieldName: string) => {
    e.stopPropagation();
    e.preventDefault();
    setCurrDropdown(getDropdownKey(props.feedback_alias, fieldName));
  };

  const updateDataOrigin = (value: string | null) => {
    const prev = props.data_origin;

    const updateValue = (data_origin: string | null) => {
      changeDataOrigin(props.feedback_alias, data_origin);
      updateDetail({
        data_origin: data_origin || undefined,
      });
    };

    try {
      updateValue(value);
    } catch (error) {
      updateValue(prev);
    }
  };

  if (!props.showFull && !props.data_origin) return null;

  return (
    <PropertyRowWrapper {...props}>
      <PropertyValue
        ref={setElementRef}
        value={props.data_origin}
        onClick={(e) => !props.isStatic && onPropertyClick(e, 'data_origin')}
        placeholder={NOT_ASSIGNED_LABEL}
      />
      <DataOriginSelectModal
        selected={props.data_origin}
        useShortcut
        name={getDropdownKey(props.feedback_alias, 'data_origin')}
        onSelect={updateDataOrigin}
        onClear={() => updateDataOrigin(null)}
        triggerEl={triggerElement}
      />
    </PropertyRowWrapper>
  );
};
